<script>

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Toast",
    meta: [
      {
        name: "toast",
      },
    ],
  },
  props: {
    message: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      i:1
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  mounted() {
    if(document.querySelector('.toast-wrapper')){
      setTimeout(()=>{
        document.querySelector('.toast-wrapper').classList.add('fade-out')
      },2000)
    }
  },
  methods: {

  },
};
</script>
<template>
  <div class="toast-wrapper" :class="action==='success' ? ' success' : ' error'">
    <p>
      {{ message }}
    </p>
  </div>
</template>

<style scoped>
.toast-wrapper{
  position:absolute;
  top:1rem;
  right:1rem;
  font-weight: 400;
  border-radius: 8px;
  font-size: 1rem;
  letter-spacing: 0.14px;
  box-shadow: rgb(76 78 100 / 42%) 0px 4px 8px -4px;
  z-index: 1400;
  animation-name:slide-in;
  animation-duration:2s;
}
.toast-wrapper.success{
  background:#56ca00;
}
.toast-wrapper.error{
  background:#ff4c51;
}
.toast-wrapper p {
  color:white;
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  flex: 1 1 auto;
  white-space: pre-line;
}
.fade-out{
  animation-name:fadeout;
  animation-duration:1s;
}
@keyframes fadeout {
  from {
    opacity:1;
  }
  to {
    opacity:0;
  }
}
@keyframes slidein {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(50px);
  }
}
</style>
